<div
  tabindex="0"
  [attr.aria-label]="'Browse files for upload'"
  class="file-upload__zone"
  [class.file-upload__zone--drag-detected]="_fileDragDetected"
  (keyup.enter)="_onBrowse()"
  (click)="_onBrowse()"
>
  <mat-icon>upload</mat-icon>
  <span class="file-upload__zone-label mat-body-2"
    >Drag & drop files to import or <b>browse</b></span
  >
</div>
